import { ThemeProvider } from '@mui/material/styles';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import {Form} from './Form';
import Header from './components/Header';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import moment from 'moment';
import { Container, Paper, Typography, CircularProgress, CssBaseline } from '@mui/material';
import { useParams } from './components/ParamsContext';
import { useConferenceConfig } from './components/ConferenceConfigContext';
import theme from './theme';


function App() {
  const {allowLateRegistration} = useParams();
  const { status, config } = useConferenceConfig();

  if (status === 'loading') {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Container sx={{ textAlign: 'center', mt: 10 }}>
          <CircularProgress />
        </Container>
      </ThemeProvider>
    );
  }

  if (status === 'error') {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Container component="form" sx={{ mb: 4 }}>
          <Paper elevation={1} sx={{ my: { xs: 3, md: 6 }, p: { xs: 3, md: 4 } }}>
            <Typography component="h1" variant="h4" align="center" gutterBottom>
              Registration is temporarily unavailable
            </Typography>
            <Typography align="center" color="text.secondary">
              Please try again shortly, or contact norcalchristianstudents@gmail.com.
            </Typography>
          </Paper>
        </Container>
      </ThemeProvider>
    );
  }

  // allowLateRegistration here is the ?allowlateregistration=true URL param
  // (see ParamsContext/index.js) - also requiring config.allowLateRegistration
  // (the "Late Registration" toggle under Special link options) means an
  // admin can turn the link off without it silently reopening registration
  // for anyone who already has/guesses the bare URL param.
  const isClosed = moment().isAfter(config.finalDeadline) && !(allowLateRegistration && config.allowLateRegistration);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Header></Header>
      <PayPalScriptProvider options={{
        "client-id": 'AT7VfSV_sgLpBdWjKFCvjTm8Lq7-hsGuD7UGMRP7AJZYOG8g8_-satOt0I_fjq_6GVN1xK_DnnlyU0dh',
        "components": "buttons,funding-eligibility",
        "enable-funding": "venmo",
      }}>

        {isClosed?
          <Container component="form" sx={{ mb: 4 }}>
            <Paper elevation={1} sx={{ my: { xs: 3, md: 6 }, p: { xs: 3, md: 4 } }}>
              <Typography component="h1" variant="h4" align="center" gutterBottom>
                Registration is now closed
              </Typography>
              <Typography align="center" color="text.secondary">
                Thanks for your interest - keep an eye out for the next conference.
              </Typography>
            </Paper>
          </Container>
          :
          <Form/>
        }
      </PayPalScriptProvider>
    </ThemeProvider>

  );
}

export default App;
